const toSafeString = (value, maxLength = 80) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed.length > maxLength ? `${trimmed.slice(0, maxLength)}...` : trimmed;
};

export const getSafeErrorDetails = (error) => {
  if (!error) {
    return { name: 'UnknownError' };
  }

  const status = Number(error?.response?.status ?? error?.status);
  const safeDetails = {
    name: toSafeString(error?.name) || 'Error',
  };

  if (Number.isFinite(status)) {
    safeDetails.status = status;
  }

  const code = toSafeString(error?.code);
  if (code) {
    safeDetails.code = code;
  }

  return safeDetails;
};

export const logSafeError = (message, error) => {
  console.error(message, getSafeErrorDetails(error));
};

export const logSafeWarning = (message, error) => {
  console.warn(message, getSafeErrorDetails(error));
};
